import React from "react";
import cn from "classnames";

import "./Typography.scss";

interface IconHeaderProps {
  variant?: string;
  children?: React.ReactNode;
  headerText?: string;
  [key: string]: unknown;
}

const IconHeader = ({
  variant,
  children,
  headerText,
  ...props
}: IconHeaderProps) => {
  const className = cn({
    [`typography--variant-${variant}`]: variant,
    "default-variant": !variant,
  });

  return (
    <div className={className} {...props}>
      {children || headerText}
    </div>
  );
};

export default IconHeader;
